import styled from 'styled-components';

export const StyledGhostBalance = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 950;
  line-height: normal;
  color: #ffe223;
  font-family: var(--font-family), Arial;
  margin-right: 4px;
  background: #000;
  border-radius: 16px;
  border: 1px solid #6701e1;
  padding-right: 6px;
  height: 16px;
  box-sizing: border-box;
  margin-top: 4px;
  margin-bottom: 4px;

  &:last-child {
    margin-right: 0;
  }

  .img-container {
    height: 18px;
    max-width: 18px;
    margin-right: 2px;

    &--balance {
      height: auto;
      width: 100%;
      object-fit: contain;
    }
  }
`;
